<template>
	<v-dialog
			content-class="addDriverStatementsWrapper"
			:value="dialog"
			fullscreen
			hide-overlay
			persistent
			transition="dialog-bottom-transition"
	>
		<div class="addDriverStatements">
			<div class="addDriverStatements_header">
				<span>Driver statement</span>
				<button type="button" @click="closeDialog">
					<svg-sprite width="20" height="20" icon-id="close"></svg-sprite>
				</button>
			</div>
			<div class="addDriverStatements_body">
				<div :class="{ 'onlyView': false }" class="fieldBlock flexBlock groupField">
					<div class="groupField_wrap">
						<field
								margin="0 10px 0 0"
								width="110px"
								label="Statements ID"
								type="number"
								:setInputValue="statementId"
								is-disabled
						></field>
						<field
								margin="0 10px 0 0"
								width="300px"
								label="Driver"
								:setInputValue="driver"
								is-disabled
						></field>
						<field
								margin="0 10px 0 0"
								width="90px"
								label="Driver type"
								:setInputValue="contractType"
								is-disabled
						></field>
						<field
								margin="0 10px 0 0"
								width="300px"
								label="Customer"
								:setInputValue="customer"
								is-disabled
						></field>
						<field
								margin="0 10px 10px 0"
								width="200px"
								type="text"
								label="Date from"
								placeholder="Enter date"
								:dateValue="dateFrom"
								is-date
								is-no-title
								is-readonly
						></field>
						<field
								margin="0 10px 10px 0"
								width="200px"
								type="text"
								label="Date to"
								placeholder="Enter to"
								:dateValue="dateTo"
								is-date
								is-no-title
								is-readonly
						></field>
						<field
								margin="0 10px 0 0"
								width="125px"
								label="Statement status"
								placeholder="Select statement status"
								@updateSelect="onAutocomplete($event, 'status_id')"
								:autocompleteValue="status_id"
								item-value="status_id"
								item-text="status"
								:items="statusList"
								:isClearable="false"
								:is-disabled="isDisabledTabs"
								is-select
						></field>
					</div>
				</div>
				<tab-block
						:tab="tab"
						:tab-list="getTabList"
						@updateTab="onTab($event, 'tab', 'secondTab')"
				>
					<v-tab-item>
						<main-table
								padding="0 0 10px"
								:flag="getConstants.TRIPS"
								height="305"
								:headers="getTripsActiveHeader"
								:listItems="tripsTableActiveList"
								:filtersList="{}"
								@updateClickButton="onClickButton($event, getConstants.TRIPS)"
								@updateEdit="onEdit"
								@updateHandleTable="onHandleTable($event, getConstants.TRIPS)"
								:is-hide-header="false"
								:items-per-page-amount="10"
								:pages="[ 10, 20, 50, 100, 200, 500, 'All' ]"
						></main-table>
					</v-tab-item>
					<v-tab-item>
						<main-table
								padding="0 0 10px"
								:flag="getConstants.FUEL"
								height="305"
								:headers="getFuelTableActiveHeader"
								:listItems="fuelTableActiveList"
								:filtersList="{}"
								@updateClickButton="onClickButton($event, getConstants.FUEL)"
								@updateEdit="onEdit"
								@updateHandleTable="onHandleTable($event, getConstants.FUEL)"
								:is-hide-header="false"
								:items-per-page-amount="10"
								:pages="[ 10, 20, 50, 100, 200, 500, 'All' ]"
						></main-table>
					</v-tab-item>
					<v-tab-item>
						<main-table
								padding="0 0 10px"
								:flag="getConstants.SCHEDULE_PAYMENTS"
								height="305"
								:headers="getSchedulePaymentsActiveHeader"
								:listItems="schedulePaymentsTableActiveList"
								:filtersList="{}"
								@updateClickButton="onClickButton($event, getConstants.SCHEDULE_PAYMENTS)"
								@updateEdit="onEdit"
								@updateHandleTable="onHandleTable($event, getConstants.SCHEDULE_PAYMENTS)"
								:is-hide-header="false"
								:items-per-page-amount="10"
								:pages="[ 10, 20, 50, 100, 200, 500, 'All' ]"
						></main-table>
					</v-tab-item>
					<v-tab-item>
						<div v-if="getEditPerm && !isDisabledTabs" class="tableTop">
							<button @click="onAdditionalPayment(true)" class="tableTop_button">
								<svg-sprite width="18" height="18" icon-id="addItem"></svg-sprite>
								<span>Add new payment</span>
							</button>
						</div>
						<main-table
								padding="0 0 10px"
								flag="creditDeductionTable"
								height="305"
								:headers="getAdditionalPaymentsHeader"
								:listItems="additionalPaymentsTableList"
								:filtersList="{}"
								@updateClickButton="onClickButton($event, getConstants.ADDITION_PAYMENTS)"
								@updateEdit="onEdit"
								@updateHandleTable="onHandleTable($event, getConstants.ADDITION_PAYMENTS)"
								:is-hide-header="false"
								:items-per-page-amount="10"
								:pages="[ 10, 20, 50, 100, 200, 500, 'All' ]"
						></main-table>
					</v-tab-item>
				</tab-block>
				<tab-block
						:tab="secondTab"
						:tab-list="getSecondTabList"
						:is-disabled="tab >= 3"
						@updateTab="onTab($event, 'secondTab', 'tab')"
				>
					<v-tab-item>
						<main-table
								padding="0 0 10px"
								:flag="getConstants.TRIPS"
								height="305"
								:headers="getTripsHeader"
								:listItems="tripsTableList"
								:filtersList="{}"
								@updateClickButton="onClickButton($event, getConstants.TRIPS)"
								@updateEdit="onEdit"
								@updateHandleTable="onHandleTable($event, getConstants.TRIPS)"
								:is-hide-header="false"
								:items-per-page-amount="10"
								:pages="[ 10, 20, 50, 100, 200, 500, 'All' ]"
						></main-table>
					</v-tab-item>
					<v-tab-item>
						<main-table
								padding="0 0 10px"
								:flag="getConstants.FUEL"
								height="305"
								:headers="getFuelTableHeader"
								:listItems="fuelTableList"
								:filtersList="{}"
								@updateClickButton="onClickButton($event, getConstants.FUEL)"
								@updateEdit="onEdit"
								@updateHandleTable="onHandleTable($event, getConstants.FUEL)"
								:is-hide-header="false"
								:items-per-page-amount="10"
								:pages="[ 10, 20, 50, 100, 200, 500, 'All' ]"
						></main-table>
					</v-tab-item>
					<v-tab-item>
						<main-table
								padding="0 0 10px"
								:flag="getConstants.SCHEDULE_PAYMENTS"
								height="305"
								:headers="getSchedulePaymentsHeader"
								:listItems="schedulePaymentsTableList"
								:filtersList="{}"
								@updateClickButton="onClickButton($event, getConstants.SCHEDULE_PAYMENTS)"
								@updateEdit="onEdit($event, getConstants.SCHEDULE_PAYMENTS)"
								@updateHandleTable="onHandleTable($event, getConstants.SCHEDULE_PAYMENTS)"
								:is-hide-header="false"
								:items-per-page-amount="10"
								:pages="[ 10, 20, 50, 100, 200, 500, 'All' ]"
						></main-table>
					</v-tab-item>
				</tab-block>
			</div>
			<button-groups
					:preloader="preloader"
					:is-btn-safe="!getEditPerm"
					@updateBtnClose="closeDialog"
					@updateSave="onSave"
			></button-groups>
		</div>
		<preload v-if="driverStatementsPreloader"></preload>
		<additional-payments
				v-if="isAdditionalPayment"
				:itemId="itemId"
				:additionalPaymentData="additionalPaymentData"
				:category="additionalPaymentsCategoryList"
				@updateClose="onAdditionalPayment(false)"
		></additional-payments>
	  <remove-block
			  v-if="isRemove"
			  :preloader="preloader"
			  @updateRemoveItem="onRemoveItem"
			  @updateRemoveClose="onRemoveClose"
	  ></remove-block>
	</v-dialog>
</template>

<script>
// vuex
import { mapActions, mapGetters } from "vuex";
// components
// import TripsTable from "@/components/Accounting/DriverStatements/AddDriverStatements/TripsTable/TripsTable";
// import CreditDeductionTable from "@/components/Accounting/DriverStatements/AddDriverStatements/CreditDeductionTable/CreditDeductionTable";
// shared
import ButtonGroups from "@/shared/ButtonGroups/ButtonGroups";
import Preload from "@/shared/Preload/Preload";
import TabBlock from "@/shared/TabBlock/TabBlock";
const RemoveBlock = () => import("@/shared/RemoveBlock/RemoveBlock");
import {
	tripsActiveHeader,
	tripsHeader,
	additionalPaymentsHeader,
	fuelTableHeader,
	fuelTableActiveHeader,
	schedulePaymentsTableActiveHeader,
	schedulePaymentsTableHeader
} from "@/components/Accounting/DriverStatements/AddDriverStatements/defaultHeader";
import AdditionalPayments from "@/components/Accounting/DriverStatements/AddDriverStatements/AdditionalPayments/AdditionalPayments";
import { DRIVER_STATEMENTS_FLAGS, PERMISSIONS } from "@/constants/constants";
import getClonedObject from "@/helper/getClonedObject";

export default {
	name: "AddDriverStatements",
	components: {
		ButtonGroups,
		Preload,
		TabBlock,
		AdditionalPayments,
		RemoveBlock
	},
	props: {
		itemId: Number,
		permissions: Object
	},
	computed: {
		...mapGetters([
			'driverStatementsPreloader',
			'tripsTableList',
			'tripsTableActiveList',
			'fuelTableList',
			'fuelTableActiveList',
			'schedulePaymentsTableList',
			'schedulePaymentsTableActiveList',
			'additionalPaymentsTableList',
			'additionalPaymentsTableActiveList',
			'driverStatementsData',
			'additionalPaymentsCategoryList'
		]),
		getConstants() {
			return DRIVER_STATEMENTS_FLAGS;
		},
		getEditPerm() {
			return this.permissions[PERMISSIONS.EDIT];
		},
		getTabList() {
			return [
				{
					text: 'Trips',
					error: false
				},
				{
					text: 'Fuel',
					error: false
				},
				{
					text: 'Schedule payments',
					error: false
				},
				{
					text: 'Additional payments',
					error: false
				}
			];
		},
		getSecondTabList() {
			return [
				{
					text: 'Trips',
					error: false
				},
				{
					text: 'Fuel',
					error: false
				},
				{
					text: 'Schedule payments (on pause)',
					error: false
				},
			];
		},
		getSchedulePaymentsHeader() {
			return schedulePaymentsTableHeader;
		},
		getAdditionalPaymentsHeader() {
			if (!this.getEditPerm || this.isDisabledTabs) {
				const cloneHeader = getClonedObject(additionalPaymentsHeader);
				cloneHeader.pop();
				return cloneHeader;
			}

			return additionalPaymentsHeader;
		},
		getTripsActiveHeader() {
			if (!this.getEditPerm || this.isDisabledTabs) {
				const cloneHeader = getClonedObject(tripsActiveHeader);
				cloneHeader.pop();
				return cloneHeader;
			}

			return tripsActiveHeader;
		},
		getTripsHeader() {
			if (!this.getEditPerm || this.isDisabledTabs) {
				const cloneHeader = getClonedObject(tripsHeader);
				cloneHeader.pop();
				return cloneHeader;
			}

			return tripsHeader;
		},
		getFuelTableActiveHeader() {
			if (!this.getEditPerm || this.isDisabledTabs) {
				const cloneHeader = getClonedObject(fuelTableActiveHeader);
				cloneHeader.pop();
				return cloneHeader;
			}

			return fuelTableActiveHeader;
		},
		getFuelTableHeader() {
			if (!this.getEditPerm || this.isDisabledTabs) {
				const cloneHeader = getClonedObject(fuelTableActiveHeader);
				cloneHeader.pop();
				return cloneHeader;
			}

			return fuelTableHeader;
		},
		getSchedulePaymentsActiveHeader() {
			return schedulePaymentsTableActiveHeader;
		},
	},
	data: () => ({
		dialog: true,
		additionalPaymentData: null,
		isAdditionalPayment: false,
		tab: 0,
		secondTab: 0,
		status_id: null,
		dateFrom: null,
		dateTo: null,
		statementId: null,
		driver: null,
		customer: null,
		contractType: null,
		tripsTable: [],
		preloader: false,
		isDisabledTabs: false,
		statusList: [ { status_id: 1, status: 'Open' }, { status_id: 2, status: 'Close' } ],
		isRemove: false,
		removeId: null
	}),
	methods: {
		...mapActions([
			'onAddItem',
			'onHandlerTable',
			'onEditDriverStatements',
			'onDriverStatementsEdit',
			'onRemoveAdditionalPayments'
		]),
		async onRemoveItem() {
			this.preloader = true;
			await this.onRemoveAdditionalPayments(this.removeId);
			this.isRemove = false;
			this.preloader = false;
		},
		onRemoveClose() {
			this.isRemove = false;
		},
		onAdditionalPayment(value) {
			this.additionalPaymentData = null;
			this.isAdditionalPayment = value;
		},
		getRemoveItem(id) {
			this.removeId = id;
			this.isRemove = true;
		},
		onHandleTable(key, nameComponent) {
			this.onHandlerTable({ key, nameComponent });
		},
		onClickButton({ key, item }, nameComponent) {
			if (nameComponent === this.getConstants.ADDITION_PAYMENTS) {
				if (key === "delete") {
					this.getRemoveItem(item.id);
				}
			} else {
				this.onAddItem({ key, item, nameComponent });
			}
		},
		onEdit({ line }, flag) {
			if (this.getEditPerm && flag) {
				this.additionalPaymentData = line;
				this.isAdditionalPayment = true;
			}
		},
		onTab(value, key, secondKey) {
			this[key] = value;
			if (value <= 2) this[secondKey] = value;
		},
		async onSave() {
			const values = {
				trips_selected: this.tripsTableActiveList,
				fuel_selected: this.fuelTableActiveList,
				// scheduled_payments: this.schedulePaymentsTableList,
				status_id: this.status_id,
				id: this.itemId
			};

			this.preloader = true;
			const status = await this.onDriverStatementsEdit(values);
			if (status) this.closeDialog();
			this.preloader = false;
		},
		closeDialog() {
			this.$emit('updateClose');
		},
		onAutocomplete({ value }, key) {
			this[key] = value?.status_id ?? value;
		}
	},
	async mounted() {
		await this.onEditDriverStatements(this.itemId);

		const {
			statement_id,
			driver,
			date_from,
			date_to,
			customer,
			contract_type,
			status_id
		} = this.driverStatementsData;

		this.statementId = statement_id;
		this.driver = driver;
		this.dateFrom = date_from;
		this.dateTo = date_to;
		this.customer = customer;
		this.contractType = contract_type;
		this.status_id = status_id;
		this.isDisabledTabs = status_id === 2;
	}
};
</script>

<style scoped lang="scss">
@import "addDriverStatements";
</style>

<style lang="scss">
.v-dialog--fullscreen {
	background: #22222d;
}
</style>
